import { useState } from "react";
import { Field, Label, Switch } from "@headlessui/react";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { EditUserViewModel, useUpdateUserActiveStatusMutation } from "../../usersApiSlice";

interface UserActiveProps {
	userInfo: EditUserViewModel;
	setErrorMessage: (message: string) => void;
}

export default function UserActiveSetting(props: UserActiveProps) {
	const [disabled, setDisabled] = useState(props.userInfo.disabled);

	const [updateAvatarSetting] = useUpdateUserActiveStatusMutation();

	function handleActiveChange() {
		updateAvatarSetting({ userId: props.userInfo.id, disabled: !disabled })
			.unwrap()
			.then(() => {
				setDisabled(!disabled);
				props.setErrorMessage("");
			})
			.catch((error) => {
				scrollTo(0, 0);
				props.setErrorMessage(`Failed to save the active setting. ${error.data}`);
			});
	}

	return (
		<div className="flex items-center">
			{disabled ? (
				<XCircleIcon className="size-18 shrink-0 text-red-500" />
			) : (
				<CheckCircleIcon className="size-18 shrink-0 text-green-500" />
			)}
			<div className="ml-4">
				<p className={`font-semibold ${disabled ? "text-red-700" : "text-green-700"}`}>
					{disabled ? "Inactive" : "Active"}
				</p>
				<Field className="flex items-center mt-1 ml-2">
					<Label className="sr-only">User Activation Toggle</Label>
					<Switch
						checked={!disabled}
						onChange={handleActiveChange}
						name="activeToggle"
						className="group relative inline-flex h-7 w-12 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-primary-600 focus:ring-offset-2 data-[checked]:bg-primary-600">
						<span
							aria-hidden="true"
							className="pointer-events-none inline-block size-6 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
						/>
					</Switch>
				</Field>
			</div>
		</div>
	);
}
